const formatItem = (item, pages) => {
    const page = pages?.find((p) => p.id === item.page);
    const pageData = page?.data.find((d) => d.id === item.pageDataId);
    if (!pageData && item.type === "page")
        return;
    return {
        id: item.id,
        name: item.type === "page" ? pageData?.name : item.text,
        ...(item.type === "page" && {
            href: pageData?.path === "/"
                ? `/${pageData.language.code.toLowerCase()}`
                : `/${pageData.language.code.toLowerCase()}${pageData.path}`,
            type: "link",
        }),
    };
};
const navbarItemsRender = (items, pages) => {
    return items
        .filter((i) => i.parent === 0)
        .map((i) => {
        return {
            ...formatItem(i, pages),
            items: items
                .filter((childItem) => childItem.parent === i.id)
                .map((childItem) => formatItem(childItem, pages)),
        };
    });
};
export default navbarItemsRender;
//# sourceMappingURL=navbarItemsRender.js.map